<template>
  <div class="py-12 px-4">
    <div class="flex flex-col items-center mb-10">
      <h2 class="text-2xl font-bold mb-2">Service</h2>
      <p class="text-gray-500 text-sm">提供サービス</p>
      <div class="w-12 h-1 bg-blue-500 mt-3 rounded"></div>
    </div>

    <div class="grid md:grid-cols-2 grid-cols-1 gap-6 max-w-4xl mx-auto">
      <div v-for="service in services" :key="service.title"
        class="border border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
        <div class="text-3xl mb-4">{{ service.icon }}</div>
        <h3 class="text-lg font-bold text-gray-800 mb-2">{{ service.title }}</h3>
        <p class="text-sm text-gray-500 mb-4 leading-relaxed">{{ service.description }}</p>
        <ul class="text-sm text-gray-600 space-y-1 mb-5">
          <li v-for="point in service.points" :key="point" class="flex items-start gap-2">
            <span class="text-blue-500 mt-0.5">✓</span>
            <span>{{ point }}</span>
          </li>
        </ul>
        <div class="flex items-center justify-between text-xs text-gray-400 border-t pt-4">
          <span>対応形態: {{ service.engagement }}</span>
          <span>{{ service.price }}</span>
        </div>
      </div>
    </div>

    <p class="text-center text-sm text-gray-400 mt-8">
      ※ 価格・期間はプロジェクト内容により異なります。まずはお気軽にご相談ください。
    </p>
  </div>
</template>

<script>
export default {
  name: 'WebDevelopment',
  data() {
    return {
      services: [
        {
          icon: '🖥️',
          title: 'Webアプリケーション開発',
          description: 'SaaSや業務システム、社内ツールの新規開発から改善まで、事業や運用に合わせたWebアプリを一貫して構築します。',
          points: [
            '要件整理・設計・実装・リリースまで一気通貫で対応',
            '業務フローに合わせた管理画面・ユーザー向け画面を設計',
            '機能追加や改善を見据えた、拡張しやすい構成で開発',
            'AWS / GCP / Azure を活用したインフラ構築と運用開始まで支援',
          ],
          engagement: '企画からリリースまで一貫対応',
          price: '要相談'
        },
        {
          icon: '🔌',
          title: 'API・バックエンド開発',
          description: '既存システムの拡張や外部連携、負荷対策まで、安定運用を見据えたバックエンド開発を行います。',
          points: [
            '外部連携や機能拡張を見据えた API の設計・実装',
            '決済・認証・通知など外部サービスとの連携開発',
            '性能改善、障害調査、保守しやすい構成への見直し',
            '継続的に開発しやすい運用フローや自動化の整備',
          ],
          engagement: '部分開発・改善対応可',
          price: '要相談'
        },
        {
          icon: '🌐',
          title: 'コーポレートサイト・LP制作',
          description: '企業サイトやサービス紹介ページ、LPを、掲載内容や導線を整理しながら更新しやすい形で制作します。',
          points: [
            '必要な情報を整理したページ構成をご提案',
            '原稿や要件に沿った、見やすく扱いやすい実装',
            'レスポンシブ対応、基本的な SEO を踏まえた制作',
            'お問い合わせフォーム実装から公開環境の整備まで対応',
          ],
          engagement: '構成設計から公開まで対応',
          price: '要相談'
        },
        {
          icon: '💬',
          title: '技術相談・スポット支援',
          description: '技術選定や設計レビュー、既存システムの課題整理など、必要なタイミングで実務に沿った相談対応を行います。',
          points: [
            '技術選定や設計方針に関する壁打ち',
            'コードレビューと品質改善に向けた具体的な提案',
            '既存システムの課題整理、原因調査、改善方針の提示',
            '開発の進め方や体制面に関する相談対応',
          ],
          engagement: 'スポット相談中心',
          price: '要相談'
        },
      ]
    }
  }
}
</script>
